/**
 * @generated SignedSource<<471b075cef8b95051a5232b0140d475c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AggregationFn = "MEAN" | "%future added value";
export type TableType = "GENERAL" | "HAZARD_GRIDDED" | "HAZARD_SITES" | "MFD_CURVES" | "MFD_CURVES_V2" | "%future added value";
export type InversionSolutionQuery$variables = {
  id: string;
};
export type InversionSolutionQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly aggregation_fn?: AggregationFn | null | undefined;
    readonly common_rupture_set?: {
      readonly file_url: string | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly created?: any | null | undefined;
    readonly file_name?: string | null | undefined;
    readonly file_size?: any | null | undefined;
    readonly file_url?: string | null | undefined;
    readonly hazard_table_id?: string | null | undefined;
    readonly id: string;
    readonly md5_digest?: string | null | undefined;
    readonly meta?: ReadonlyArray<{
      readonly k: string | null | undefined;
      readonly v: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly mfd_table?: {
      readonly id: string;
    } | null | undefined;
    readonly mfd_table_id?: string | null | undefined;
    readonly produced_by?: {
      readonly id?: string;
    } | null | undefined;
    readonly relations?: {
      readonly total_count: number | null | undefined;
    } | null | undefined;
    readonly source_solution?: {
      readonly created: any | null | undefined;
      readonly id?: string;
      readonly produced_by?: {
        readonly __typename: string;
        readonly id?: string;
      } | null | undefined;
    } | null | undefined;
    readonly source_solutions?: ReadonlyArray<{
      readonly file_name?: string | null | undefined;
      readonly file_url?: string | null | undefined;
      readonly id?: string;
    } | null | undefined> | null | undefined;
    readonly tables?: ReadonlyArray<{
      readonly created: any | null | undefined;
      readonly table_id: string | null | undefined;
      readonly table_type: TableType | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type InversionSolutionQuery = {
  response: InversionSolutionQuery$data;
  variables: InversionSolutionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "file_name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "file_url",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "file_size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "md5_digest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyValuePair",
      "kind": "LinkedField",
      "name": "meta",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "k",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "v",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FileRelationConnection",
      "kind": "LinkedField",
      "name": "relations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FileInterface",
  "abstractKey": "__isFileInterface"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mfd_table_id",
  "storageKey": null
},
v8 = [
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Table",
  "kind": "LinkedField",
  "name": "mfd_table",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hazard_table_id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "LabelledTableRelation",
  "kind": "LinkedField",
  "name": "tables",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "table_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "table_type",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "InversionSolution",
  "abstractKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "produced_by",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v15/*: any*/)
  ],
  "type": "InversionSolutionInterface",
  "abstractKey": "__isInversionSolutionInterface"
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "common_rupture_set",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregation_fn",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "type": "FileInterface",
  "abstractKey": "__isFileInterface"
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "AggregateInversionSolution",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "InversionSolution",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "ScaledInversionSolution",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "TimeDependentInversionSolution",
  "abstractKey": null
},
v24 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InversionSolutionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "produced_by",
                "plural": false,
                "selections": [
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "type": "InversionSolutionInterface",
            "abstractKey": "__isInversionSolutionInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InversionSolution",
                "kind": "LinkedField",
                "name": "source_solution",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TimeDependentInversionSolution",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source_solution",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ScaledInversionSolution",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source_solutions",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AggregateInversionSolution",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source_solution",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "InversionSolutionNrml",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InversionSolutionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v24/*: any*/),
          (v3/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v15/*: any*/),
              (v13/*: any*/)
            ],
            "type": "InversionSolutionInterface",
            "abstractKey": "__isInversionSolutionInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InversionSolution",
                "kind": "LinkedField",
                "name": "source_solution",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v3/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TimeDependentInversionSolution",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source_solution",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ScaledInversionSolution",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source_solutions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AggregateInversionSolution",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "source_solution",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "InversionSolutionNrml",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8abb8e1e0f1672b6636af8b14e276a53",
    "id": null,
    "metadata": {},
    "name": "InversionSolutionQuery",
    "operationKind": "query",
    "text": "query InversionSolutionQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    __isNode: __typename\n    id\n    ... on FileInterface {\n      __isFileInterface: __typename\n      file_name\n      file_url\n      file_size\n      md5_digest\n      meta {\n        k\n        v\n      }\n      relations {\n        total_count\n      }\n    }\n    ... on InversionSolutionInterface {\n      __isInversionSolutionInterface: __typename\n      mfd_table_id\n      mfd_table {\n        id\n      }\n      hazard_table_id\n      created\n      produced_by {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      tables {\n        table_id\n        table_type\n        created\n      }\n    }\n    ... on TimeDependentInversionSolution {\n      source_solution {\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        created\n        id\n      }\n    }\n    ... on ScaledInversionSolution {\n      source_solution {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on InversionSolution {\n          created\n        }\n        ... on InversionSolutionInterface {\n          __isInversionSolutionInterface: __typename\n          created\n          produced_by {\n            __typename\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n    ... on AggregateInversionSolution {\n      common_rupture_set {\n        id\n        file_url\n      }\n      aggregation_fn\n      source_solutions {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on FileInterface {\n          __isFileInterface: __typename\n          file_name\n          file_url\n        }\n      }\n    }\n    ... on InversionSolutionNrml {\n      source_solution {\n        __typename\n        ... on AggregateInversionSolution {\n          id\n        }\n        ... on InversionSolution {\n          id\n        }\n        ... on ScaledInversionSolution {\n          id\n        }\n        ... on TimeDependentInversionSolution {\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4805689964789fe67686ea5a7f2ee6c";

export default node;
